"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "condofuri": {
    "26dd74a9": [{
      "hkey": "07c098c9",
      "slug": "san-carlo-condofuri-marina",
      "name": "San Carlo-Condofuri Marina",
      "primary": true,
      "skipSearch": false
    }],
    "condofuri-marina": [{
      "hkey": "07c098c9",
      "slug": "san-carlo-condofuri-marina",
      "name": "San Carlo-Condofuri Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "condofuri"
    }],
    "0372f11a": [{
      "hkey": "07c098c9",
      "slug": "san-carlo-condofuri-marina",
      "name": "San Carlo-Condofuri Marina",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "07c098c9",
      "slug": "san-carlo-condofuri-marina",
      "name": "San Carlo-Condofuri Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;